<div class="row justify-content-center mb-5">
  <div class="col-12">
    @if (showActions && !isEdit && isCreator) {
      <div class="d-flex justify-content-end action-wrap">
        <div
          class="btn"
          (click)="viewDraft()"
          [class.btn-grey]="isPublished"
          [class.btn-primary]="!isPublished"
        >
          {{ (isPublished ? 'campaign.viewDraft' : 'campaign.viewPublished') | translate }}
        </div>
        @if (
          !(campaignStatus === CampaignStatus.Success || campaignStatus === CampaignStatus.Fail)
        ) {
          <div class="btn btn-green" (click)="addUpdate()">
            {{ 'campaign.postNewUpdate' | translate }}
          </div>
        }
      </div>
    }
    @if (!isEdit) {
      @if (!isLoading) {
        <ul class="timeline">
          @for (update of updates; track update; let i = $index) {
            <li class="timeline-item">
              <div class="left">
                <div class="text-green font-weight-bold font-size-larger">
                  {{
                    (isPublished ? update.publishedAt : update.createdAt) | amDateFormat: 'D MMM'
                  }}
                </div>
                <div class="year">
                  {{ (isPublished ? update.publishedAt : update.createdAt) | amDateFormat: 'YYYY' }}
                </div>
                <div class="profile d-flex justify-content-end mt-3">
                  <img
                    class="profile-image"
                    [alt]="update.creator?.fullName"
                    [src]="update.creator?.photoAttachmentUrl || DefaultProfileImage"
                  />
                </div>
              </div>
              <div class="right">
                <div class="d-flex mb-3 align-items-center">
                  <div class="font-weight-bold text-black update-title w-100">
                    {{ update.title }}
                  </div>
                  @if (showActions && isCreator) {
                    <div class="action-panel d-flex">
                      <div
                        class="pitchin-icon pitchin-icon-edit-black mr-3"
                        (click)="editUpdates(update)"
                      ></div>
                      <div
                        class="pitchin-icon pitchin-icon-delete"
                        (click)="deleteUpdates(update.id)"
                      ></div>
                    </div>
                  }
                </div>
                <ng-container>
                  <div
                    class="description mb-3 ck-content content-display"
                    [innerHTML]="update.content | trustSrc"
                  ></div>
                  <div class="d-flex flex-wrap">
                    <div class="time">
                      {{ transformDate(update.modifiedAt) }} {{ 'common.by' | translate }}
                      <span class="creator">{{ update.creator?.fullName }}</span>
                    </div>
                    @if (update.isCreator) {
                      <div class="role">
                        {{ 'campaign.creator' | translate }}
                      </div>
                    }
                  </div>
                </ng-container>
              </div>
            </li>
          }
        </ul>
      }
      <div class="row">
        @if (isLoading) {
          <div class="col-12">
            <agmo-loading></agmo-loading>
          </div>
        }
        @if (!isLoading && (!updates || updates.length == 0)) {
          <div class="col-12 py-5 text-center">
            <app-empty-state [message]="'common.noUpdate'"></app-empty-state>
          </div>
        }
        @if (updates && total > updates.length) {
          <div class="col-12 d-flex my-3 p-0">
            <div class="view-more" (click)="loadMore()">
              {{ 'common.viewMore' | translate }}
            </div>
          </div>
        }
      </div>
    }
    @if (isEdit) {
      <div class="row mb-4">
        <div class="col-12">
          <h4 class="font-weight-extrabold">{{ 'campaign.postNewUpdate' | translate }}</h4>
        </div>
      </div>
      @if (form && ckEditorLoaded) {
        <form (ngSubmit)="submit(true)" [formGroup]="form" [class.show-form-error]="showFormError">
          <div class="row">
            <div class="col-lg-12 input-panel">
              <div class="input-label">{{ 'campaign.updateTitle' | translate }}</div>
              <div class="input-field">
                <input
                  class="form-control"
                  formControlName="title"
                  type="text"
                  [placeholder]="'campaign.updateTitlePlaceholder' | translate"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 input-panel" id="content">
              <div class="input-label">{{ 'campaign.updateContent' | translate }}</div>
              <div class="input-field">
                <ckeditor
                  class="ck-editor"
                  formControlName="content"
                  (focus)="removeRichText($event)"
                  [editor]="Editor"
                  [config]="ckEditorConfig"
                ></ckeditor>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-lg-6 col-md-4 col-12 input-panel d-flex">
              <div class="btn-cancel" (click)="cancel()">{{ 'common.cancel' | translate }}</div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 input-panel text-right">
              <div class="btn btn-grey w-100" (click)="submit(false)">
                {{ 'common.saveAsDraft' | translate }}
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 input-panel text-right">
              <button class="btn btn-green w-100" type="submit">
                {{ 'common.submit' | translate }}
              </button>
            </div>
          </div>
        </form>
      }
    }
  </div>
</div>
